import "./StatusBadge.css";

export type OrderStatus = "pending" | "sent" | "completed" | "failed";

type StatusBadgeProps = {
  status: OrderStatus;
};

const STATUS_CONFIG: Record<OrderStatus, { label: string; className: string }> =
  {
    pending: { label: "Afventer", className: "StatusBadge--pending" },
    sent: { label: "Sendt", className: "StatusBadge--sent" },
    completed: { label: "Gennemført", className: "StatusBadge--completed" },
    failed: { label: "Fejlet", className: "StatusBadge--failed" },
  };

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <span className={`StatusBadge ${config.className}`}>{config.label}</span>
  );
};
